import React from "react";
import {
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,

} from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import ReactGA from "react-ga4";

import {
	NPSFeedbackList
} from '../../components/nps-feedback/';

class NSPFeedback extends React.Component {

	constructor(props) {
    super(props);

  }

	componentDidMount() {
		ReactGA.pageview(window.location.pathname);
	}

	render() {
		return (
			<div>
				<Row>
					<Col md="12">
            <NPSFeedbackList />
					</Col>
				</Row>
			</div>
		);
	}
}

export default NSPFeedback;
